export const SETTINGS_ACCESS = Object.freeze({
  READ: 'settings:read',
  MANAGE: 'settings:manage',
  PORTABLE_TRANSFER: 'settings:portable-transfer',
});

function normalizedRoles(user) {
  if (Array.isArray(user?.roles)) return user.roles;
  return user?.role ? [user.role] : [];
}

export function hasSettingsCapability(user, capability) {
  if (!user) return false;
  if (capability === SETTINGS_ACCESS.READ) return true;
  if (capability === SETTINGS_ACCESS.MANAGE) {
    return normalizedRoles(user).includes('admin');
  }
  if (capability === SETTINGS_ACCESS.PORTABLE_TRANSFER) {
    return normalizedRoles(user).some((role) => role === 'admin' || role === 'designer');
  }
  return false;
}

export function allowedSettingsSections(sections, user) {
  return sections.filter((section) => (
    hasSettingsCapability(user, section.requiredCapability)
  ));
}
